import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
// import FormComponent from "./FormComponent";
import ReduxFormComponent from "./ReduxFormComponent";
import WhyToBook from "./WhyToBook";
import PriceSummarySticky from "./PriceSummarySticky";
import styles from "./index.module.css";
import { connect } from "react-redux";
import { graphql, gql, withApollo } from "react-apollo";
import {
  updateBathrooms,
  updateBedrooms,
  updateFrequency,
  updateDate,
  updateTime
} from "../../../actions/CleaningActions";

class FormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextRef: null
    };
  }
  componentDidMount = () => {
    // this.props
    //   .mutate()
    //   .then(data => {
    //     console.log(data);
    //   })
    //   .catch(err => console.log(err));
  };
  handleContextRef = contextRef => this.setState({ contextRef });
  render() {
    const { contextRef } = this.state;
    const { bedrooms, bathrooms, discount, price, frequency } = this.props;
    const { user } = this.props.data;
    return (
      <div
        style={{
          paddingTop: "10vh",
          paddingBottom: "10vh",
          width: "100vw",
          backgroundColor: "#f3f3f3",
          minHeight: "100vh",
          textAlign: "center"
        }}
      >
        <h2>You're a step away from a happy home</h2>
        <Grid padded columns={2}>
          <Grid.Row>
            <Grid.Column
              className={styles.noPaddingMobile}
              mobile={16}
              tablet={12}
              computer={12}
            >
              {user ? (
                <ReduxFormComponent
                  numBedrooms={bedrooms}
                  numBathrooms={bathrooms}
                  discount={discount}
                  price={price}
                  frequency={frequency}
                  initialValues={{
                    frequency,
                    numBathrooms: bathrooms,
                    numBedrooms: bedrooms,
                    selectedDate: this.props.date,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    email: user.email,
                    phone: user.phone,
                    address: user.address,
                    city: user.city,
                    zip: user.zip,
                    selectedTime: "13:00"
                  }}
                  loggedIn={true}
                  updateBathrooms={this.props.updateBathrooms}
                  updateBedrooms={this.props.updateBedrooms}
                  updateFrequency={this.props.updateFrequency}
                  updateDate={this.props.updateDate}
                  updateTime={this.props.updateTime}
                />
              ) : (
                <ReduxFormComponent
                  numBedrooms={bedrooms}
                  numBathrooms={bathrooms}
                  discount={discount}
                  price={price}
                  frequency={frequency}
                  initialValues={{
                    frequency,
                    numBathrooms: bathrooms,
                    numBedrooms: bedrooms,
                    selectedDate: this.props.date,
                    selectedTime: "13:00"
                  }}
                  updateBathrooms={this.props.updateBathrooms}
                  updateBedrooms={this.props.updateBedrooms}
                  updateFrequency={this.props.updateFrequency}
                  updateDate={this.props.updateDate}
                  updateTime={this.props.updateTime}
                />
              )}
              <PriceSummarySticky user={user} />
            </Grid.Column>
            <Grid.Column
              only="computer tablet"
              width={4}
              style={{ paddingRight: "2rem" }}
            >
              <WhyToBook />
              {/* <PriceSummarySticky user={user} /> */}
            </Grid.Column>
          </Grid.Row>
          {/* <Grid.Row only="mobile" columns={1}>
            <Grid.Column className={styles.noPaddingMobile}>
              <PriceSummarySticky user={user} />
            </Grid.Column>
          </Grid.Row> */}
        </Grid>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateBathrooms: num => {
      dispatch(updateBathrooms(num));
    },
    updateBedrooms: num => {
      dispatch(updateBedrooms(num));
    },
    updateFrequency: freq => {
      dispatch(updateFrequency(freq));
    },
    updateDate: date => {
      dispatch(updateDate(date));
    },
    updateTime: time => {
      dispatch(updateTime(time));
    }
  };
};
const mapStateToProps = (state, ownProps) => {
  return {
    bathrooms: state.cleaning.bathrooms,
    bedrooms: state.cleaning.bedrooms,
    frequency: state.cleaning.frequency,
    price: state.cleaning.price,
    discount: state.cleaning.discount,
    date: state.cleaning.date,
    time: state.cleaning.time
  };
};

const myQuery = gql`
  query loginQuery {
    user: loggedInUser {
      id
      lastName
      firstName
      zip
      address
      city
      email
      phone
    }
  }
`;
FormContainer = graphql(myQuery, {
  options: {
    fetchPolicy: "cache-and-network"
  }
})(FormContainer);
export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/index.jsx